module.exports = __webpack_public_path__ + "media/images/talent/case5-img01-a7e6ddcadd9f217c85e9de0fb26c2dd2.png";